export default __webpack_public_path__ + "static/media/MadalinaMezei.67040b7f.png";